// Safely access import.meta.env with fallback for Retool that does not have env variables
const env =
  (typeof import.meta !== 'undefined' && import.meta.env) ||
  ({} as Record<string, string | undefined>);

const {
  VITE_API_BASE_URL,
  VITE_NEO4J_URL: neo4jUrl,
  VITE_NEO4J_USERNAME: neo4jUsername,
  VITE_NEO4J_PASSWORD: neo4jPassword,
  VITE_KEYCLOAK_URL: keycloakUrl,
  VITE_KEYCLOAK_REALM: keycloakRealm,
  VITE_KEYCLOAK_CLIENT_ID: keycloakClientId,
  VITE_SHOW_MODELS: showModelSelector,
  VITE_REASONER_DEFAULT_MODEL: reasonerDefaultModel,
  VITE_UNSTRUCTURED_DATA_LOADER_DEFAULT_MODEL:
    unstructuredDataLoaderDefaultModel,
  VITE_ENRICHER_DEFAULT_MODEL: enricherDefaultModel,
  VITE_LINKING_DEFAULT_MODEL: linkingDefaultModel,
  VITE_EMBEDDING_DEFAULT_MODEL: embeddingDefaultModel,
  VITE_STORAGE_PROVIDER: storageProvider,
  VITE_API_AUTH_TYPE,
  VITE_CONFIG_STORAGE: configStorage,
  VITE_DASHBOARD_POLLING_INTERVAL: dashboardPollingIntervalEnv,
} = env;

// let apiBaseUrl so it can be overridden dynamically in Retool as it dosen't support env variables
let apiBaseUrl = VITE_API_BASE_URL;
export function setApiBaseUrl(url: string) {
  apiBaseUrl = url;
}

const apiAuthType = VITE_API_AUTH_TYPE ?? 'keycloak';

// Dashboard polling interval (ms) — set via VITE_DASHBOARD_POLLING_INTERVAL.
// Values below 2000ms (including 0) are ignored and fall back to the minimum (2000ms)
// to prevent excessive API calls. Set 0 or omit the env var to use the minimum.
const MIN_DASHBOARD_POLLING_INTERVAL = 2000;
const parsedPollingInterval = Number(dashboardPollingIntervalEnv);
const dashboardPollingInterval = !parsedPollingInterval || parsedPollingInterval < MIN_DASHBOARD_POLLING_INTERVAL
  ? MIN_DASHBOARD_POLLING_INTERVAL
  : parsedPollingInterval;

/** Public asset base (`import.meta.env.BASE_URL`). Used for paths under `/public`. */
export function getViteBaseUrl(): string {
  const base = (env as { BASE_URL?: string }).BASE_URL;
  if (typeof base === 'string' && base.length > 0) {
    return base.endsWith('/') ? base : `${base}/`;
  }
  return '/';
}

export {
  apiBaseUrl,
  neo4jUrl,
  neo4jUsername,
  neo4jPassword,
  keycloakUrl,
  keycloakRealm,
  keycloakClientId,
  showModelSelector,
  reasonerDefaultModel,
  unstructuredDataLoaderDefaultModel,
  enricherDefaultModel,
  linkingDefaultModel,
  embeddingDefaultModel,
  storageProvider,
  apiAuthType,
  configStorage,
  dashboardPollingInterval,
};
